import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import N_tick from "../../../../src/assets/images/N_tick.png";
import N_wws_warehousing from "../../../assets/images/warehousing_icon.png";
import N_wws_Stockpoint from "../../../assets/images/stock.png";
import port_icon from "../../../assets/images/port_icon.png";
import test_icon from "../../../assets/images/test_icon.png";
import ServiceContact from "../../../_Pages/_webapp/OurServises/ServiceContact";
import Subscribe from "../../../_Pages/_webapp/_mainHome/Subscribe";
import WebFooter from "../../../_components/_webapp/Footer/WebFooter";

class WweFinancial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "en",
    };
  }
  componentDidMount() {
    let lang = localStorage.getItem("lang");
    this.setState({
      lang: lang,
    });
  }
  render() {
    const metaTags = document.getElementsByTagName("meta");
    for (const tag of metaTags)
      if (tag.name === "description")
        tag.content =
          "Arya serves the financial institution and offers services like collateral management, stock audits for commodity loans and cash credit/OD loans, consulting on commodity based finance etc.";

    return (
      <React.Fragment>
        <SetHeader active={"story"} history={this.props.history}></SetHeader>

        <Helmet>
          <title>Who we Serve | Financial Institution | Arya</title>
          <meta
            name="keywords"
            content="Warehouse near me, paddy warehouse, Maize Warehouse, Sugar warehouse, Wheat warehouse, Soyabean warehouse, Rice warehouse, Cotton warehouse, List your warehouse, Buy sell paddy online, Buy sell maize online, Buy sell pulses online, Buy sell spices online, Get loan on agri products, Get loan on agri commodities, Get finance on your commodities, paddy stock near me, maize Stock near me, Wheat stock near me, Bajra Stock near me, Jowar stock near me, Sugar stock near me, Soybean Stock near me, Cotton stock near me, Rice stock near me"
          />
        </Helmet>

        <section className="Whoweservebanner Financial_Banner">
          <Container>
            <Row>
              <Col>
                <div className="wws_banner_portion">
                  <div className="wws_banner_heading">
                    <h1>
                      {localStorage.getItem("warehouseCount")
                        ? localStorage.getItem("warehouseCount") + "+"
                        : "9600+"}
                      <MultiLanguageTranslation title=" Warehouses Across " />
                      {localStorage.getItem("districtCount")
                        ? localStorage.getItem("districtCount") + "+"
                        : "800+"}
                      <MultiLanguageTranslation title=" Locations" />
                    </h1>
                  </div>
                  <div className="wws_banner_heading_content">
                    <a href="/WhoWeServeFPO">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Farmer & FPO" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Processor">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Processors" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Agri_corporation">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Agri Corporations" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Financial">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Financial Institutions" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/InternationalBuyer">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="International Buyers" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/DevelopmentActors">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Development Actors" />
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="NA_customBreadcumb">
                <Link onClick={() => this.props.history.push("/")}>
                  <MultiLanguageTranslation title="Arya.ag" />
                </Link>{" "}
                <span>→</span>{" "}
                <Link onClick={() => this.props.history.push("/WhoWeServe")}>
                  <MultiLanguageTranslation title="Who We Serve" />
                </Link>{" "}
                <span>→</span>
                <span className="breadcrumb_active">
                  <MultiLanguageTranslation title="Financial Institution" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <section className="N_wws">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="N_wws_heading">
                  <h2>
                    <MultiLanguageTranslation title="Financial Institution" />
                  </h2>
                </div>
                <div className="wws_desc">
                  <p>
                    <MultiLanguageTranslation title="Financial_page_title_Financial_Institutions_play" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="N_wws_offer_por">
          <Container>
            <Row>
              <Col>
                <div className="N_wws_offer">
                  <div className="N_wws_offer_heading">
                    <h4>
                      <MultiLanguageTranslation title="Our Offerings" />
                    </h4>
                  </div>
                  <div className="N_wws_offer_content-sec">
                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_warehousing} />
                      <h5>
                        <MultiLanguageTranslation title="Collateral Management" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Stockpoint} />
                      <h5>
                        <MultiLanguageTranslation title="Stock Audits for Commodity Loans" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={test_icon} />
                      <h5>
                        <MultiLanguageTranslation title="Stock and Receivable’s Audits for Cash Credit / OD Loans" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={port_icon} />
                      <h5>
                        <MultiLanguageTranslation title="Consulting On Priority Sector Lending" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Stockpoint} />
                      <h5>
                        <MultiLanguageTranslation title="Consulting On Commodity Based Finance" />
                      </h5>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <ServiceContact />

        <section className="formContent">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>
                  <MultiLanguageTranslation title="fi_h1" />
                </h1>

                <p>
                  <MultiLanguageTranslation title="fi_p1" />
                </p>

                <h2>
                  <MultiLanguageTranslation title="Arya in Finance Commodities to Help Farmers" />
                </h2>
                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="fi_p2" />
                  ) : (
                    <>
                      Financial institutions play a critical role in the
                      agriculture value chain's strengthening. Through their
                      goods and structures, they meet the financial demands of
                      the many organizations involved. ARYA aids Financial
                      Institutions in effectively deploying such products and
                      structures through its different services. We deal in{" "}
                      <b>finance commodities</b> so that the farmers can enjoy
                      their harvest in the best manner. The better quality they
                      generate, the better will be served on our plate, and
                      hence it is important to finance this sector, and we at
                      ARYA understand it to the core.
                    </>
                  )}
                </p>

                <h3>
                  <MultiLanguageTranslation title="Agri Commodity Financing for Small and Marginal Farmers" />{" "}
                </h3>
                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="fi_p3" />
                  ) : (
                    <>
                      Small and marginal farmers own 85 percent of India's total
                      cultivable land. Despite the fact that they make up a
                      sizable section of the producer community, their value
                      realization across the whole agriculture value chain is
                      severely restricted. ARYA has been working hard to
                      increase the value realization for these farmers through
                      its numerous services like <b>Agri commodity financing</b>
                      . It collaborates with Farmer Producer Organizations, such
                      as Producer Companies and Cooperatives, to help
                      small-scale farmers earn more money.
                    </>
                  )}
                </p>
                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="fi_p4" />
                  ) : (
                    <>
                      We at ARYA also offer <b>warehouse receipt financing</b>
                      for the betterment of the farmers. We have been bridging
                      the gap so that the farmers of the country get the value
                      that they deserve.
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="N_stay_update">
          <div className="container">
            <div className="row">
              <Subscribe></Subscribe>
            </div>
          </div>
        </section>
        <WebFooter />
      </React.Fragment>
    );
  }
}
export default WweFinancial;
